function isDesktop() {
  return window.innerWidth >= 1024;
}

function subscribeElements(elements) {
  elements.forEach(({ key, customElement }) => {
    if(!window.customElements.get(key)) {
      window.customElements.define(key, customElement)
    }
  })
}

function subscribeEvents(eventListeners) {
  Object.entries(eventListeners).forEach(([event, callback]) => {
    let target = [document];
    const [evt, selector] = event.split(' ')

    if (selector) {
      target = document.querySelectorAll(selector);
      event = evt
    }

    Array.from(target).map(element => element.addEventListener(event, callback));
  })
}

function formatMoney(amount, currency = 'BRL', locale = 'pt-BR') {
  const number = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(number)) return '';

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
}

function collapsibleElements(selector) {
  Array.from(document.querySelectorAll(selector)).map(item => 
    item.addEventListener('click', function(e) {
      e.target.classList.toggle('open')
      e.target.nextElementSibling?.classList.toggle('hidden')
    }))
}

function cartChangedListener() {
  const addToCartForms = document.querySelectorAll('form[action^="/cart/add"]');

  addToCartForms.forEach(form => {
    form.addEventListener('submit', function(event) {
      const formData = new FormData(form);
      const variantId = formData.get('id');
      const quantity = formData.get('quantity') || 1;

      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            variantId: variantId,
            quantity: parseInt(quantity, 10)
          }
        }));
      }, 1000);
    });
  });
}

function addToCartButtonFixed() {
  if (!document.querySelector('button[name="add"]') || !document.querySelector('.buy-buttons--fixed')) {
    return
  }
  
  const distanceY = document.querySelector('button[name="add"]').getClientRects()[0].y

  if (distanceY < 0) {
    return document.querySelector('.buy-buttons--fixed').classList.remove('!hidden')
  }

  document.querySelector('.buy-buttons--fixed').classList.add('!hidden')
}

function boxItems() {
  const boxItems = document.querySelectorAll('.block-box');

  console.log('boxItems', boxItems)

  if (!boxItems.length) {
    return;
  }

  const container = document.createElement('div');
  container.classList.add('block-box-container', 'tw-grid', `sm:grid-cols-${boxItems.length}`, 'gap-4');

  boxItems[0].parentNode.insertBefore(container, boxItems[0]);

  boxItems.forEach(item => {
    container.appendChild(item);
  })
}

const EventListeners = {
  'DOMContentLoaded'(e) {
    collapsibleElements('footer .footer-menu-items .collapsible')
    cartChangedListener()
    boxItems()
  },
  'scroll'(e) {
    addToCartButtonFixed()
  },
};

const CustomElement = class extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {}
  disconnectedCallback() {}
  attributeChangedCallback(name, oldValue, newValue) {}
};

// js/common/search-bar-autocomplete.js
const SearchBarAutocomplete = class extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this._autocompleteSearchBar();
    this._openSearchDesktop();
    this._openSearchMobile() 
  }
  _autocompleteSearchBar() {
    console.log('[search-bar]: initialized')
    const searchInput = document.querySelector("#search-input");
    const mobSearchBar = document.querySelector('#search-icon-mob');
    const searchResults = document.querySelector("#search-results");
    const closeBtn = document.querySelector('.header_search-bar .close');
    const searchLink = document.querySelector('.header_search-bar .search-by-term');

    function toggleSearch(type) {
      const hiddenItems = ['close', 'dbr-search-results']
      const fn = type == 'close' ? 'setAttribute' : 'removeAttribute'
      
      hiddenItems.forEach(item => document.querySelector('.header_search-bar .'+item)[fn]('hidden', true));

      if (type == 'close') {
        document.getElementById('search-bar-backdrop').classList.add('hidden')
        document.querySelector('.header_search-bar').classList.remove('opened')
        closeBtn.classList.add('hidden')
        document.querySelector('.header_search-bar').classList.remove('absolute')
      }
      //['top-0', 'fixed'].forEach(item => document.querySelector('.header_search-bar').classList[type == 'close' ? 'remove' : 'add'](item))
    }

    mobSearchBar.addEventListener('click', function() {
      document.querySelector('.header_search-bar').classList.remove('hidden')
      document.querySelector('.header_search-bar .close').classList.remove('hidden')
      document.querySelector('#search-input').focus()
    });

    searchInput.addEventListener("keyup", function(e) {
      if (e.keyCode == 13) {
        location.href = searchLink.href
      }
    })

    searchInput.addEventListener("input", function(e) {
      let query = searchInput.value.trim();
      document.querySelector("#term").innerHTML = query; 
      searchLink.href = `/search?q=${query}`
      if (query.length < 2) {
        // toggleSearch('close');
        return;
      }

      const limit = isDesktop() ? 6 : 2;

      fetch(`/search/suggest.json?q=${query}&resources[type]=product&resources[limit]=${limit}`)
        .then(response => response.json())
        .then(data => {
            searchResults.innerHTML = "";
            let products = data.resources.results.products;

            if (!products.length) {
              searchResults.textContent = 'No results found'
            }

            toggleSearch();
            products.forEach(product => {
                let item = document.createElement("div");
                item.classList.add("autocomplete-item");
                item.innerHTML = `
                    <a href="${product.url}" class="autocomplete-product flex flex-col justify-between gap-3 relative">
                        ${product.tags[0] ? 
                          `
                            <span class="absolute top-[1rem] text-sm rounded-full bg-primary-base text-white py-0 px-2">${product.tags[0]}</span>
                          ` : ''}
                        <div class="w-[170px] rounded bg-neutral-100">
                          <img
                            src="${product.image}" 
                            alt="${product.title}"
                          />
                        </div>
                        <strong class="text-xs sm:text-sm">${product.title}</strong>
                        <div class="text-base sm:text-lg flex self-start items-center gap-2">
                          ${product.compare_at_price_min > 0 ? 
                            `<span class="text-neutral-400 line-through">${formatMoney(product.compare_at_price_min)}</span>` : ``
                          }
                          <strong class="text-primary-base">${formatMoney(product.price_min)}</strong>
                        </div>
                    </a>
                `;
                searchResults.appendChild(item);
            });
        })
        .catch(error => console.error("Error fetching search suggestions:", error))
    });

    closeBtn.addEventListener('click', function() {
      toggleSearch('close');
      if (isDesktop()) document.querySelector('.header_search-bar').classList.add('hidden')
      if (!isDesktop()) document.querySelector('.close').classList.add('hidden')
  
      searchInput.value = '';
    })

    document.getElementById('search-bar-backdrop').addEventListener('click', function() {
      toggleSearch('close');
    });
  }
  _openSearchMobile() {
    const openSearch = document.querySelector('#search-input');

    openSearch.addEventListener('input', function() {
      document.querySelector('.close').classList.remove('hidden')
      document.getElementById('search-bar-backdrop').classList.remove('hidden')
      document.querySelector('.header_search-bar').classList.add('opened')
      document.querySelector('.header_search-bar').classList.add('absolute')
    });
  }
  _openSearchDesktop() {
    const openSearch = document.querySelector('#search-bar');

    openSearch.addEventListener('click', function() {
      document.querySelector('.header_search-bar').classList.remove('sm:hidden')
      document.querySelector('#search-input').focus()
      document.querySelector('.header_search-bar').classList.add('absolute')
    });
    
  }
};

//js/common/menu-side-bar
const SideBarMenu = class extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const btn = document.getElementById('toggleSidebar');
    const close = document.getElementById('close-sidebar');
    const sidebar = document.getElementById('sidebar');
    const backdrop = document.getElementById('backdrop');

    function toggleSidebar() {
      const isOpen = sidebar.classList.toggle('translate-x-full') === false;
      backdrop.classList.toggle('hidden', !isOpen);
    }

    btn.addEventListener('click', toggleSidebar);
    close.addEventListener('click', toggleSidebar);
    backdrop.addEventListener('click', toggleSidebar);
  }
}

//js/common/accordion
class Accordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const btn = this.querySelector('.toggle-btn');
    const content = this.querySelector('.content');

    btn.addEventListener('click', () => {
      content.classList.toggle('hidden');
      this.querySelector('.toggle-icon.minus').classList.toggle('block');
      this.querySelector('.toggle-icon.plus').classList.toggle('hidden');
      this.querySelector('.toggle-icon.minus').classList.toggle('hidden');
      this.querySelector('.toggle-icon.plus').classList.toggle('block');
    });
  }
}

//js/common/custom-slider
class CustomSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Usamos this para garantir que selecionemos elementos apenas deste componente específico
    const wrapper = this.querySelector('.custom-slider-track-wrapper');
    const track = this.querySelector('.custom-slider-track');
    const next = this.querySelector('.slider-nav.next');
    const prev = this.querySelector('.slider-nav.prev');
    const dots = this.querySelectorAll('.custom-slider-dots .dot');

    if (!wrapper || !track) return;

    const slides = track.querySelectorAll('.custom-slide');
    if (!slides.length) return;

    // Calculamos a largura de cada slide (incluindo a margem)
    const slideWidth = slides[0].offsetWidth + parseFloat(getComputedStyle(slides[0]).marginRight) * 2;
    
    // Calculamos quantos slides cabem na tela visível
    const visibleWidth = wrapper.clientWidth;
    const slidesPerView = Math.max(1, Math.floor(visibleWidth / slideWidth));
    
    // Calculamos o número de páginas (grupos de slides)
    const totalPages = Math.ceil(slides.length / slidesPerView);
    
    let currentPage = 0;

    function updateDots(index) {
      dots.forEach(dot => dot.classList.remove('active'));
      if (dots[index]) dots[index].classList.add('active');
    }

    function scrollToPage(page) {
      // Garantimos que a página esteja dentro dos limites
      const targetPage = Math.max(0, Math.min(page, totalPages - 1));
      
      // Calculamos a posição para onde rolar
      const scrollPosition = targetPage * slidesPerView * slideWidth;
      
      // Fazemos a rolagem
      wrapper.scrollTo({ left: scrollPosition, behavior: 'smooth' });
      
      // Atualizamos o estado
      currentPage = targetPage;
      updateDots(currentPage);
    }

    // Configuramos os botões de navegação
    next?.addEventListener('click', () => {
      scrollToPage(currentPage + 1);
    });

    prev?.addEventListener('click', () => {
      scrollToPage(currentPage - 1);
    });

    // Configuramos os dots
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        scrollToPage(index);
      });
    });

    // Sincronizamos os dots com a rolagem
    let isScrolling;
    wrapper.addEventListener('scroll', () => {
      // Cancelamos o temporizador anterior
      clearTimeout(isScrolling);
      
      // Configuramos um novo temporizador
      isScrolling = setTimeout(() => {
        // Calculamos qual página está visível
        const scrollPosition = wrapper.scrollLeft;
        const newPage = Math.round(scrollPosition / (slidesPerView * slideWidth));
        
        // Se a página mudou, atualizamos o estado
        if (newPage !== currentPage) {
          currentPage = newPage;
          updateDots(currentPage);
        }
      }, 50);
    });
  }
}

class CartProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.loadRecommendations()
    document.addEventListener("cart:updated", function() {
      this.loadRecommendations()
    });
  }

  loadRecommendations() {
    const recommendationsContainer = document.querySelector('.cart-recommendations');
    const productId = this.dataset.productId;
    const url = `/recommendations/products.json?product_id=${productId}&limit=2`

    if (productId) {
      fetch(url)
        .then(response => response.json())
        .then(data => {
          const products = data.products || [];
          const grid = recommendationsContainer.querySelector('.recommendations-grid');

          if (products.length) {
            products.forEach(product => {
              const itemHTML = `
                <div class="recommendation-item w-[170px] relative">
                  <a href="${product.url}">
                    ${product.tags[0] ? 
                          `
                            <span class="absolute top-[1rem] text-sm rounded-full bg-primary-base text-white py-0 px-2">${product.tags[0]}</span>
                          ` : ''}
                    <div class="bg-neutral-100 rounded-xl w-[130px]">
                      <img class="mix-blend-multiply" src="${product.featured_image}" alt="${product.title}">
                    </div> 
                    
                    <p class="text-primary-base text-sm font-bold">${product.title}</p>
                    <div class="flex items-center gap-1 mt-1">
                      <p class="text-neutral-light text-sm line-through">${formatMoney(product.compare_at_price_max / 100)}</p>
                      <p class="text-primary-base font-bold text-lg">${formatMoney(product.price_max / 100)}</p>
                    </div>
                    <p class="text-neutral-light text-xs">or ${installment_count}x installments of ${formatMoney((product.price_max / 100) / installment_count)}</p>

                    
                    <form action="/cart/add" method="post" enctype="multipart/form-data" class="mt-2">
                      <input type="hidden" name="id" value="${product.variants[0].id}">
                      <input type="hidden" name="quantity" value="1">
                      <button type="submit" class="text-sm w-full bg-primary-base text-white py-1 px-2 rounded-xl font-medium hover:bg-primary-base hover:text-primary-base transition-colors">
                        SHOP
                      </button>
                    </form>
                  </a>
                </div>
              `;
              grid.insertAdjacentHTML('beforeend', itemHTML);
            });
            document.querySelector('.product-recommendations__title').classList.remove('hidden')
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  }
}

subscribeElements([
  {
    key: 'custom-element',
    customElement: CustomElement
  },
  {
    key: 'search-bar-autocomplete',
    customElement: SearchBarAutocomplete
  },
  {
    key: 'menu-side-bar',
    customElement: SideBarMenu
  },
  {
    key: 'custom-accordion',
    customElement: Accordion
  },
  {
    key: 'custom-slider',
    customElement: CustomSlider
  },
  {
    key: 'cart-product-recommendations',
    customElement: CartProductRecommendations
  }
]);

subscribeEvents(EventListeners);
